<eca-pillar-box class="profile-content">
  <eca-dynamic-notification-window [notificationInputStream]="notificationSource"></eca-dynamic-notification-window>
  @if (profileForm && (validationRules$ | async); as validationRules) {
    <eca-form-column>
      <span class="logo-group">
        <eca-drc-insight-logo></eca-drc-insight-logo>
      </span>
      <form [formGroup]="profileForm" (ngSubmit)="onSubmitForm($event)" autocomplete="off" novalidate>
        <h1 class="eca-skip-link-focus-target" tabindex="-1">{{formTitle}}</h1>
        <p>{{formSubtitle}}</p>
        <ng-content select=".ng-content-before"></ng-content>
        <div class="group-form">
          <mat-form-field class="eca-login-component-field eca-password-composite-field reduced-space">
            <mat-label>New Password </mat-label>
            <input matInput formControlName="newPassword" name="newPassword" id="newPassword" [type]="manageNewPasswordType"
              tabindex="0" minlength="8" maxlength="127" required (focus)="updateCapsLockErrorState($event)"
              (focusout)="updateCapsLockErrorState($event)" (keyup)="passwordInputKeyUp$.next($event.target.value)">
            <mat-checkbox matSuffix [disabled]="formDisabled" (change)="togglePasswordText('manageNewPasswordType')">Show Text</mat-checkbox>
            <span [hidden]="!(newPasswordCapsLockError===true && capslock===true)" class="caps-lock-tooltip subtitle-2">
              Caps Lock is on
            </span>
          </mat-form-field>
          @if (!newPasswordTouched && validationRules) {
            <div>
              <ul class="new-password-errors">
                @for (item of validationRules.checks; track item) {
                  <li> <span> {{item.rule}}</span></li>
                }
              </ul>
            </div>
          }
          @if (newPasswordTouched && validationRules) {
            <div>
              <ul class="new-password-errors validated-password">
                @for (item of validationRules.checks; track item) {
                  <li> <span
                    class="{{item.valid===true? 'valid-item': 'invalid-item' }}">
                    @if (item.valid) {
                      <span>&#10003; &nbsp;</span>
                    }
                    @if (!item.valid) {
                      <span>&#x2717; &nbsp;</span>
                    }
                    <span> {{item.rule}}</span></span>
                  </li>
                }
              </ul>
            </div>
          }
          <mat-form-field class="eca-login-component-field eca-password-composite-field reduced-space">
            <mat-label>Confirm New Password</mat-label>
            <input matInput formControlName="newPasswordConfirm" name="newPasswordConfirm"
              (focus)="updateCapsLockErrorState($event)" (focusout)="updateCapsLockErrorState($event)"
              [type]="managePasswordConfirmType" required>
            <span [hidden]="!(newPasswordConfirmCapsLockError===true && capslock===true)"
              class="caps-lock-tooltip subtitle-2">
              Caps Lock is on
            </span>
            <mat-checkbox matSuffix [disabled]="formDisabled" (change)="togglePasswordText('managePasswordConfirmType')">Show Text</mat-checkbox>
          </mat-form-field>
          <div>
            @if (newPasswordConfirm.touched) {
              <ul class="new-password-errors validated-password">
                @if (!validateNewPasswordConfirm() && profileForm.get('newPasswordConfirm').hasError('passwordNotEquivalent')) {
                  <li
                    >
                    <span class="invalid-item">
                      <span>&#x2717; &nbsp;</span>
                      <span> New and confirmation passwords do not match</span>
                    </span>
                  </li>
                }
                @if (newPasswordConfirm.touched && !(profileForm.get('newPasswordConfirm').hasError('passwordNotEquivalent'))) {
                  <li>
                    <span class="valid-item">
                      <span>
                        <span>&#10003; &nbsp;</span>
                        <span>
                        Confirmation password matches with new password</span>
                      </span>
                    </span>
                  </li>
                }
              </ul>
            }
            @if (!newPasswordConfirm.touched) {
              <ul class="new-password-errors">
                <li> <span> New and confirmation passwords must match</span></li>
              </ul>
            }
          </div>
          <div class="eca-form-column-buttons">
            <button mat-button color="primary" [disabled]="profileForm.invalid || checkStatus !== 'OK' || formDisabled"
              name="btnSubmit" type="submit">
              {{saveButtonText}}
            </button>
            @if (cancelButtonText) {
              <button mat-button (click)="onCancelClick()" type="button" name="btnCancel"
                >
                {{cancelButtonText}}
              </button>
            }
          </div>
        </div>
        <ng-content select=".ng-content-after"></ng-content>
      </form>
    </eca-form-column>
  }
</eca-pillar-box>
